<template>
  <div>
    <div class="content">
      <van-cell-group>
        <van-cell title="医院" :value="dietaryguidancDetails.hospitalName" />
        <van-cell title="患者姓名" :value="dietaryguidancDetails.patientName" />
        <div v-if="breakfastFoods.length">
          <van-cell title="早餐"></van-cell>
          <van-cell :label="'备注：' + dietaryguidancDetails.breakfastRemark">
            <template class="foodsContent" #title>
              <span
                style="color: #969799"
                v-for="item in breakfastFoods"
                :key="item.id"
              >
                {{ item.foodName + item.foodNumber + item.foodUnit }}
              </span>
            </template>
          </van-cell>
        </div>
        <div v-if="lunchFoods.length">
          <van-cell title="午餐"></van-cell>
          <van-cell :label="'备注：' + dietaryguidancDetails.extraRemark">
            <template class="foodsContent" #title>
              <span
                style="color: #969799"
                v-for="item in lunchFoods"
                :key="item.id"
              >
                {{ item.foodName + item.foodNumber + item.foodUnit }}
              </span>
            </template>
          </van-cell>
        </div>
        <div v-if="supperFoods.length">
          <van-cell title="晚餐"></van-cell>
          <van-cell :label="'备注：' + dietaryguidancDetails.supperRemark">
            <template class="foodsContent" #title>
              <span
                style="color: #969799"
                v-for="item in supperFoods"
                :key="item.id"
              >
                {{ item.foodName + item.foodNumber + item.foodUnit }}
              </span>
            </template>
          </van-cell>
        </div>
        <div v-if="extraFoods.length">
          <van-cell title="加餐"></van-cell>
          <van-cell :label="'备注：' + dietaryguidancDetails.extraRemark">
            <template class="foodsContent" #title>
              <span
                style="color: #969799"
                v-for="item in extraFoods"
                :key="item.id"
              >
                {{ item.foodName + item.foodNumber + item.foodUnit }}
              </span>
            </template>
          </van-cell>
        </div>
        <div class="van-cell-content">
          <div class="first">
            <p class="van-cell-class">
              <span>能量</span>
              <span>{{ dietaryguidancDetails.energy || 0 }}千卡</span>
            </p>
            <p class="van-cell-class">
              <span>蛋白质</span>
              <span>{{ dietaryguidancDetails.protein || 0 }}g</span>
            </p>
          </div>
          <div class="last">
            <p class="van-cell-class">
              <span>脂肪</span>
              <span>{{ dietaryguidancDetails.fat || 0 }}g</span>
            </p>
            <p class="van-cell-class">
              <span>碳水化合物</span>
              <span>{{ dietaryguidancDetails.carbohydrate || 0 }}g</span>
            </p>
          </div>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import { queryDietaryguidance } from "@/api/dietaryguidance/dietaryguidance";
import { reactive, toRefs } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const state = reactive({
      dietaryguidancId: route.params.id,
      dietaryguidancDetails: "",
      breakfastFoods: "",
      supperFoods: "",
      extraFoods: "",
      lunchFoods: "",
    });

    // 获取膳食指导接口
    queryDietaryguidance({
      id: state.dietaryguidancId,
    }).then((v) => {
      const { data } = v;
      const { breakfastFoods, supperFoods, extraFoods, lunchFoods } = data;
      state.breakfastFoods = JSON.parse(breakfastFoods);
      state.supperFoods = JSON.parse(supperFoods);
      state.extraFoods = JSON.parse(extraFoods);
      state.lunchFoods = JSON.parse(lunchFoods);
      state.dietaryguidancDetails = data;
      console.log(state.breakfastFoods);
    });

    return {
      ...toRefs(state),
      queryDietaryguidance,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;
  .van-cell-content {
    .first, .last {
      display: flex;
      p {
        flex: 1;
      }
    }
    p:nth-child(odd) {
      border-right: 1px solid #ebedf0;
    }
    p:nth-child(1) {
      border-bottom: 1px solid #ebedf0;
    }
    p:nth-child(2) {
      border-bottom: 1px solid #ebedf0;
    }
    p:nth-child(even) {
      float: right;
    }
    .van-cell-class {
      padding: 10px 16px;
      span {
        margin-right: 10px;
        color: var(--basic-labe);
      }
      span:last-of-type {
        color: #969799;
      }
    }
  }
  :deep(.van-cell__title) {
    color: var(--basic-labe);
    span {
      margin-right: 10px;
    }
  }
  :deep(.van-cell) {
    border-bottom: 1px solid #ebedf0;
  }
}
</style>
